import React from 'react';
import {obterContratoPeloNumero} from '../actions/ContratoActions';
import {deletarPublicacao, editarPublicacao} from '../actions/PublicacaoActions';
import {connect} from 'react-redux';
import BoxPublicacoes from '../components/BoxPublicacoes';
import {toast} from 'react-toastify';
import {FTP_URL} from '../config/urls';
import {Link} from 'react-router-dom'
import axios from 'axios';
import {REQUEST_URL} from '../config/urls'

class Publicacoes2 extends React.Component {
  state = {
    contrato: "",
    publicacao: null,
    publicacoes: {
			paginacao: [],
			capaDura: [],
			embalagens: [],
			encarte: [],
			conviteSimples: [],
			senhaDeEntrada: [],
			missal: [],
      outrosProdutos: [],
      personalizadas: []
		},
		paginas: [],
		historico: [],
    renderizarPublicacao: false
  }

  buscarPublicacoes(event){
    event.preventDefault();
    let novaPub = {
			paginacao: [],
			capaDura: [],
			embalagens: [],
			encarte: [],
			conviteSimples: [],
			senhaDeEntrada: [],
			missal: [],
      outrosProdutos: [],
      personalizadas: []
    };
    if (this.state.contrato !== "" && this.state.contrato > 0) {
      this.setState({buscando:true, publicacoes: novaPub});
      this.props.obterContratoPeloNumero(this.state.contrato).then(() => {
        let publicacoes = {
          paginacao: [],
          capaDura: [],
          embalagens: [],
          encarte: [],
          conviteSimples: [],
          senhaDeEntrada: [],
          missal: [],
          outrosProdutos: [],
          personalizadas: []
        }
        this.props.contrato.publicacoes.forEach(publicacao => {
          switch(publicacao.tipo){
            case 'Paginação':
              publicacoes.paginacao.push(publicacao);
              break;
            case 'Capa Dura':
              publicacoes.capaDura.push(publicacao);
              break;
            case 'Embalagem':
              publicacoes.embalagens.push(publicacao);
              break;
            case 'Encarte':
              publicacoes.encarte.push(publicacao);
              break;
            case 'Convite Simples':
              publicacoes.conviteSimples.push(publicacao);
              break;
            case 'Senha de Entrada':
              publicacoes.senhaDeEntrada.push(publicacao);
              break;
            case 'Missal':
              publicacoes.missal.push(publicacao);
              break;
            case 'Outros Produtos':
              publicacoes.outrosProdutos.push(publicacao);
              break;
            case 'Personalizadas':
              publicacoes.personalizadas.push(publicacao);
              break;
          }
        });
        publicacoes.paginacao      = publicacoes.paginacao.sort((a, b)      => new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime());
        publicacoes.capaDura       = publicacoes.capaDura.sort((a, b)       => new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime());
        publicacoes.embalagens     = publicacoes.embalagens.sort((a, b)     => new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime());
        publicacoes.encarte        = publicacoes.encarte.sort((a, b)        => new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime());
        publicacoes.conviteSimples = publicacoes.conviteSimples.sort((a, b) => new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime());
        publicacoes.senhaDeEntrada = publicacoes.senhaDeEntrada.sort((a, b) => new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime());
        publicacoes.missal         = publicacoes.missal.sort((a, b)         => new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime());
        publicacoes.outrosProdutos = publicacoes.outrosProdutos.sort((a, b) => new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime());
        publicacoes.personalizadas = publicacoes.personalizadas.sort((a, b) => new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime());
        
        this.setState({publicacoes,buscando:false, renderizarPublicacao: true});
      }).catch(e => { 
        toast.error("Este contrato não existe");
        this.setState({publicacoes: novaPub, buscando: false, renderizarPublicacao: false});
      });
    } else {
      toast.error("É necessário digitar um número maior que zero");
    }
  }

	_renderPublicacoes(){
    return(
      <div>
        {
          this.state.buscando ?
            "Aguarde ..."
          : this.props.contrato.publicacoes !== undefined ? 
            this.props.contrato.publicacoes.length === 0 ?
              <div className="alert alert-info alert-dismissible">
              <button type="button" className="close" data-dismiss="alert" aria-hidden="true">×</button>
                <h4>Ainda não foram feitas publicações deste contrato!</h4>
              </div>
            : null
          : null
        }
        {
          this.state.publicacoes.paginacao.length > 0 ?
            <BoxPublicacoes publicacoes={this.state.publicacoes.paginacao} renderToFechamento={false} tipo="paginacao" id={this.state.contrato} pubId={this.state.publicacoes.paginacao[0].id} titulo="Paginação" onClick={() => {this.setState({paginas: this.state.publicacoes.paginacao[0].paginas})}}/>
          : null
        }
        {
          this.state.publicacoes.capaDura.length > 0 ?
            <BoxPublicacoes publicacoes={this.state.publicacoes.capaDura} renderToFechamento={false} tipo="capa-dura" id={this.state.contrato} pubId={this.state.publicacoes.capaDura[0].id} titulo="Capa Dura" onClick={() => {this.setState({paginas: this.state.publicacoes.capaDura[0].paginas})}}/>
          : null
        }
        {
          this.state.publicacoes.embalagens.length > 0 ?
            <BoxPublicacoes publicacoes={this.state.publicacoes.embalagens} renderToFechamento={false} tipo="embalagens" id={this.state.contrato} pubId={this.state.publicacoes.embalagens[0].id} titulo="Embalagens" onClick={() => {this.setState({paginas: this.state.publicacoes.embalagens[0].paginas})}}/>
          : null
        }
        {
          this.state.publicacoes.encarte.length > 0 ?
            <BoxPublicacoes publicacoes={this.state.publicacoes.encarte} renderToFechamento={false} tipo="encarte" id={this.state.contrato} pubId={this.state.publicacoes.encarte[0].id} titulo="Encarte" onClick={() => {this.setState({paginas: this.state.publicacoes.encarte[0].paginas})}}/>
          : null
        }
        {
          this.state.publicacoes.conviteSimples.length > 0 ?
            <BoxPublicacoes publicacoes={this.state.publicacoes.conviteSimples} renderToFechamento={false} tipo="convite-simples" id={this.state.contrato} pubId={this.state.publicacoes.conviteSimples[0].id} titulo="Convite Simples" onClick={() => {this.setState({paginas: this.state.publicacoes.conviteSimples[0].paginas})}}/>
          : null
        }
        {
          this.state.publicacoes.senhaDeEntrada.length > 0 ?
            <BoxPublicacoes publicacoes={this.state.publicacoes.senhaDeEntrada} renderToFechamento={false} tipo="senha-de-entrada" id={this.state.contrato} pubId={this.state.publicacoes.senhaDeEntrada[0].id} titulo="Senha de Entrada" onClick={() => {this.setState({paginas: this.state.publicacoes.senhaDeEntrada[0].paginas})}}/>
          : null
        }
        {
          this.state.publicacoes.missal.length > 0 ?
            <BoxPublicacoes publicacoes={this.state.publicacoes.missal} titulo="Missal" renderToFechamento={false} tipo="missal" id={this.state.contrato} pubId={this.state.publicacoes.missal[0].id} onClick={() => {this.setState({paginas: this.state.publicacoes.missal[0].paginas})}}/>
          : null
        }
        {
          this.state.publicacoes.outrosProdutos.length > 0 ?
            <BoxPublicacoes publicacoes={this.state.publicacoes.outrosProdutos} renderToFechamento={false} tipo="outros-produtos" id={this.state.contrato} pubId={this.state.publicacoes.outrosProdutos[0].id} titulo="Outros Produtos" onClick={() => {this.setState({paginas: this.state.publicacoes.outrosProdutos[0].paginas})}}/>
          : null
				}
        {
          this.state.publicacoes.personalizadas.length > 0 ?
            <BoxPublicacoes publicacoes={this.state.publicacoes.personalizadas} renderToFechamento={false} tipo="personalizadas" id={this.state.contrato} pubId={this.state.publicacoes.personalizadas[0].id} titulo="Personalizadas" onClick={() => {this.setState({paginas: this.state.publicacoes.personalizadas[0].paginas})}}/>
          : null
				}
			</div>
    )
  }

  render(){
    return(
			<div>
				<div className="box">
					<div className="box-body">
						<h3 style={{color: "rgba(0, 0, 0, 0.85)"}}>Buscar Publicação</h3>
						<form onSubmit={this.buscarPublicacoes.bind(this)}>
							<div className="input-group">
								<input type="number" value={this.state.contrato} placeholder="Número do contrato" min="0" onChange={(event) => this.setState({contrato: event.target.value})} className="form-control" />
								<div className="input-group-btn">
									<button type="submit" className="btn btn-flat btn-primary">Buscar contrato</button>
								</div>
							</div>
						</form>
					</div>
				</div>
				{
					this.state.renderizarPublicacao ?
						this._renderPublicacoes()
					: null
				}
			</div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario :state.usuario.autenticado,
    contrato: state.contrato.especifico
  }
}

export default connect(mapStateToProps, {obterContratoPeloNumero, deletarPublicacao, editarPublicacao})(Publicacoes2);



// WEBPACK FOOTER //
// ./src/views/Publicacoes2.js